"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var MultiselectTextfield = (0, material_1.styled)(function (props) { return ((0, jsx_runtime_1.jsx)(TextField_1.default, __assign({ InputProps: { disableUnderline: true, hiddenLabel: true }, autoFocus: true, variant: "filled" }, props))); })(function (_a) {
    var _b, _c;
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return ({
        color: theme.palette.riverstone,
        '.MuiFilledInput-root': {
            color: 'inherit',
            padding: theme.spacing(1),
            backgroundColor: theme.palette.common.white,
            borderRadius: 5,
            transition: 'none !important',
            '&.Mui-focused, &.Mui-disabled': {
                backgroundColor: theme.palette.common.white,
            },
            ':before, :after': {
                borderBottom: '1px solid #eaecef',
            },
            ':hover': {
                backgroundColor: theme.palette.common.white,
                ':before, :after': {
                    borderBottom: '1px solid #eaecef',
                },
            },
            '.Mui-disabled': {
                opacity: 0.38,
            },
        },
        '.MuiOutlinedInput-root': {
            lineHeight: '20px',
            color: 'inherit',
            fieldset: { padding: 0 },
            legend: { width: 'unset' },
            '&.MuiInputBase-sizeSmall': {
                padding: 0,
                input: {
                    padding: theme.spacing(0.75, 1, 0.75, 2),
                    height: 'auto',
                },
                ' .MuiInputAdornment-sizeSmall': {
                    marginLeft: 0,
                    minWidth: theme.spacing(4),
                },
                ' .MuiAutocomplete-input': {
                    padding: theme.spacing(0.75, 4, 0.75, 2),
                    height: 'auto',
                    width: 'auto',
                },
            },
            '> .MuiOutlinedInput-notchedOutline': {
                borderColor: (props === null || props === void 0 ? void 0 : props.color) && ((_b = theme.palette[props.color || 'primary']) === null || _b === void 0 ? void 0 : _b.light),
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 1 },
            '&:hover': {
                ':not(.Mui-disabled):not(.Mui-error) > .MuiOutlinedInput-notchedOutline': {
                    borderColor: (_c = theme.palette[props.color || 'primary']) === null || _c === void 0 ? void 0 : _c.main,
                },
            },
        },
        '& .MuiFormHelperText-root': {
            fontSize: 12,
            lineHeight: '14px',
            margin: 0,
            textAlign: 'center',
        },
    });
});
exports.default = MultiselectTextfield;
